import {
  FulfillmentTypeId,
  InventoryTypeId,
  InventoryVehicle,
  VehicleOffering,
  VehiclePrice
} from '@carvana/merch-contracts';

type DefaultVehicle = Omit<InventoryVehicle, 'price'> & { price: VehiclePrice };

const defaultVehicle: DefaultVehicle = {
  backSeatImageUrl: '',
  bodyStyle: 'Sedan',
  color: 'Black',
  drivingMiles: 999,
  earliestDaysToDeliveryOrPickupType: 'Pickup',
  earliestLocalLocation: {
    locationId: 71,
    activityType: 'unknown'
  },
  entireDashImageUrl: '',
  fuelType: 'Plug-In Hybrid',
  fulfillmentType: FulfillmentTypeId.Unknown,
  imageUrl: '',
  infotainmentImageUrl: '',
  interiorColor: 'Black',
  isLockedByCurrentUser: false,
  isNewSinceLastVisit: false,
  isOnDemand: false,
  isPurchasePending: false,
  jellyBeanDesktopUrl: '',
  jellyBeanMobileUrl: '',
  kbbTrim: '',
  locationId: 43,
  make: '',
  matchedFilters: {},
  mileage: 0,
  milesPerGallon: 37,
  missingFilters: {},
  model: '',
  offering: VehicleOffering.Unspecified,
  parentModel: '',
  passengerSeatImageUrl: '',
  price: {
    apr: 0.9,
    discounts: [],
    downPayment: 0,
    evTaxCredit: 0,
    evTaxCreditAppliedPrice: 0,
    feesMinusShipping: 9999,
    kbbValue: 999999,
    minimumDown: 0,
    monthlyPayment: 500,
    pricingErrorMessage: '',
    term: 72,
    total: 99999,
    totalDiscountAmount: 0,
    totalFees: 9999,
    totalTaxes: 9999,
    transportCost: 0
  },
  priceUpdateDate: '2024-05-10T20:39:38.94Z',
  seatingCapacity: 4,
  steeringImageUrl: '',
  stockNumber: 0,
  stockRecallStatusType: 0,
  storeKey: 'None',
  stores: [],
  textlessUrl: '',
  trim: '',
  trunkImageUrl: '',
  vdpSlug: '',
  vehicleId: 0,
  vehicleInventoryType: InventoryTypeId.Core,
  vehicleLockType: 0,
  vehiclePurchaseType: 'Unavailable',
  vehicleReservableReasons: [],
  vehicleTags: [],
  vin: '',
  year: 0
};

export default defaultVehicle;
